module.exports = __webpack_public_path__ + "media/assets/images/flags/gy-343d2920dd87e5e72b02ffa903a82bb6.svg";